/**
 * src/gm/platform/config.ts — 引擎常量区：端点、重试上限、键前缀、容量纪律。
 * 纪律（设计稿 §7）：公式数值不在这里——它们运行时从存档 market 键现读。
 */

/** Moonshot chat completions 端点（spike 实测 CORS 全链路通过，零代理） */
export const API_ENDPOINT = 'https://api.moonshot.cn/v1/chat/completions'

/** 显式 max_tokens（spike §2：默认值未探明，不要赌） */
export const MAX_TOKENS = 32768

/** 限流/5xx 指数退避：3 次，2s / 8s / 20s */
export const RETRY_DELAYS_MS = [2000, 8000, 20000]

/** 校验反馈重试上限：≤2 轮（= 最多 3 次尝试）（剧本 §3.3/§4.2/§5） */
export const MAX_VALIDATE_ROUNDS = 2

/** 程序岗流中断续写上限：1 次 */
export const MAX_CONTINUATIONS = 1

/** 冒烟超时 */
export const SMOKE_TIMEOUT_MS = 8000

// ── 持久键（tp3:* 命名空间，引擎自有；设计稿 §8.2 分治：外壳拥有 thirdplay:v2:*）──
const SESSION_PREFIX = 'tp3:session'
const EVENTS_PREFIX = 'tp3:events'
const ARTIFACT_PREFIX = 'tp3:artifact'

export function sessionKey(projectId: string, stage: string): string {
  return `${SESSION_PREFIX}:${projectId}:${stage}`
}
export function sessionPrefixOf(projectId: string): string {
  return `${SESSION_PREFIX}:${projectId}:`
}
export function eventsKey(projectId: string): string {
  return `${EVENTS_PREFIX}:${projectId}`
}
/** 全局审计视图（封盘摘要、跨项目事件）；capped */
export const GLOBAL_EVENTS_KEY = `${EVENTS_PREFIX}:_global`
/** 唤醒队列（单键数组，Phase A 深度 ≤1，留多项目形状） */
export const WAKEUP_KEY = 'tp3:wakeup'

/** last-failure：事故情报（上一轮死因），一次性消费——再派一轮时喂回程序员后即删 */
export type ArtifactKind = 'design-doc' | 'art-spec' | 'assets-css' | 'index-html' | 'last-failure'
export function artifactKey(projectId: string, kind: ArtifactKind): string {
  return `${ARTIFACT_PREFIX}:${projectId}:${kind}`
}

/** 结算脏标记（结算中途崩溃，下次启动优先补完） */
export const PENDING_SETTLEMENT_KEY = 'tp3:pending-settlement'

/** 评审员笔名（同季度同一支笔，记入存档侧键而非 schema 锁定的 save） */
export const REVIEWER_PEN_NAME_KEY = 'tp3:reviewer-pen-name'

/** 全局事件段保留条数上限（设计稿 §3.2：capped 500） */
export const GLOBAL_EVENT_CAP = 500
/** 项目事件段安全上限（正常单循环百级，防失控） */
export const PROJECT_EVENT_CAP = 2000
/** 唤醒队列终态记录保留上限 */
export const WAKEUP_TERMINAL_CAP = 50

/** 流式进度快照节流（设计稿 §3.1：约每 500ms 一条 stream-snapshot） */
export const STREAM_SNAPSHOT_INTERVAL_MS = 500
/** 程序岗 partialRaw 持久化节流：每收约 2K 字符落一次（设计稿 §2.3） */
export const PARTIAL_SNAPSHOT_MIN_CHARS = 2000

/** localStorage 容量预警阈值：估算占用超 80% 提示导出/清理 */
export const STORAGE_WARN_RATIO = 0.8
export const STORAGE_BUDGET_BYTES = 5 * 1024 * 1024
